export const buildUIPAuthHeaders = (
  accessToken: string | null | undefined,
): Record<string, string> => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${String(accessToken || "")}`,
});

export const buildUIPMultipartAuthHeaders = (
  accessToken: string | null | undefined,
): Record<string, string> => ({
  Authorization: `Bearer ${String(accessToken || "")}`,
});
